<template>
    <div class="stepper-wrap">

        <!-- TOOLBAR -->
        <step-dots :step="step" :labels="stepLabels" can-skip @back="goBack" @skip="finishStepper(true)"/>

        <!-- STEPPER WINDOW -->
        <v-window v-model="carousel" touchless>
            <!-- BASIC INFO -->
            <v-window-item>
                <basic-info-stepper @change="basicInfoData" ref="basicInfo"/>
            </v-window-item>
            <!-- SPORT RECORD -->
            <v-window-item>
                <sport-record @change="sportRecordData"/>
            </v-window-item>
            <!-- OBJECTIVE WITH BUILDER -->
            <v-window-item>
                <choose-objectives @change="objectivesArray = $event"
                    title-key="entrance.objective_with_builder" subtitle-key="entrance.subtext_objective" />
            </v-window-item>
            <!-- PLACE OF TRAINING -->
            <v-window-item>
                <place-training @change="selectedPlace = $event"/>
            </v-window-item>
            <!-- EQUIPMENT AVAILABLE -->
            <v-window-item>
                <choose-equipments-stepper @change="equipmentsArray = $event"/>
            </v-window-item>
        </v-window>

        <div class="container-bottom">
            <v-btn @click="continueStepper" color="primary" depressed large block
                   class="black--text text-none font-weight-bold" :loading="overlay">
                {{ $t('common.continue') }}
            </v-btn>
            <logout-button outlined color="txtSecondary" large block class="mt-3"/>
        </div>

        <v-overlay z-index="50" :value="overlay">
            <v-progress-circular color="primary" indeterminate size="64"/>
        </v-overlay>

    </div>
</template>

<script>
import {db} from '@/utils/Firebase'
import StepDots from "@/components/entrance/elements/StepDots";
import BasicInfoStepper from "@/components/entrance/elements/BasicInfoStepper";
import SportRecord from "@/components/student/SportRecord";
import ChooseObjectives from "@/components/common/ChooseObjectives";
import PlaceTraining from "@/components/student/PlaceTraining";
import ChooseEquipmentsStepper from "@/components/student/ChooseEquipmentsStepper";
import LogoutButton from "@/components/common/inputs/LogoutButton";

export default {
    components: {
        LogoutButton,
        StepDots,
        BasicInfoStepper,
        SportRecord,
        ChooseObjectives,
        PlaceTraining,
        ChooseEquipmentsStepper,
    },
    data() {
        return {
            carousel: 0,
            overlay: false,
            // Step 1
            name: '',
            phone: '',
            phoneCode: '',
            birthDate: '',
            gender: '',
            country: '',
            // Step 2
            height: '',
            weight: '',
            trainingDays: 0,
            sportSelected: '',
            // Step 3
            objectivesArray: [],
            // Step 4
            selectedPlace: [],
            // Step 5
            equipmentsArray: [],
        }
    },
    computed: {
        step(vm = this) {
            return vm.carousel + 1
        },
        stepLabels(vm = this) {
            return [
                vm.$t('entrance.step_basic'),
                vm.$t('entrance.step_sport'),
                vm.$t('entrance.step_objective'),
                vm.$t('entrance.step_place'),
                vm.$t('entrance.step_equipment'),
            ]
        },
    },
    methods: {
        basicInfoData(payload) {
            const vm = this
            vm.name = payload.name || ''
            vm.phone = payload.phone || ''
            vm.phoneCode = payload.phoneCode || ''
            vm.birthDate = payload.birthDate || ''
            vm.gender = payload.gender || ''
            vm.country = payload.country || ''
        },
        sportRecordData(payload) {
            const vm = this
            vm.height = payload.height || ''
            vm.weight = payload.weight || ''
            vm.trainingDays = payload.trainingDays || 0
            vm.sportSelected = payload.sportSelected || ''
        },
        continueStepper() {
            const vm = this
            if (vm.carousel === 0) vm.$refs.basicInfo.emitNow()
            if (vm.carousel === 0 && (!vm.name || (!vm.phone || vm.phone.length < 8))) return vm.toast(vm.$t('entrance.required_name_phone'), 'error')
            if (vm.carousel === 0 && !vm.phoneCode) return vm.toast(vm.$t('entrance.required_phone_code'), 'error')
            if (vm.carousel !== 4) return vm.carousel++
            vm.finishStepper()
        },
        async finishStepper(skip = false) {
            const vm = this
            let payload = {}
            vm.overlay = true

            if (skip) {
                if (vm.carousel === 0) vm.$refs.basicInfo.emitNow()
                if (vm.carousel === 0 && (!vm.name || (!vm.phone || vm.phone.length < 8))) {
                    vm.overlay = false
                    return vm.toast(vm.$t('entrance.required_name_phone'), 'error')
                }
                if (vm.carousel === 0 && !vm.phoneCode) {
                    vm.overlay = false
                    return vm.toast(vm.$t('entrance.required_phone_code'), 'error')
                }

                payload.name = vm.name
                payload.phone = vm.phone
            } else {
                // Step 1
                if (vm.name) payload.name = vm.name
                if (vm.phone) payload.phone = vm.phone
                if (vm.phoneCode) payload.phoneCode = vm.phoneCode
                if (vm.birthDate) payload.birthDate = vm.birthDate
                if (vm.gender) payload.gender = vm.gender
                if (vm.country) payload.country = vm.country
                // Step 2
                if (vm.height !== '') payload.height = vm.height
                if (vm.weight !== '') payload.weight = vm.weight
                payload.trainingDays = vm.trainingDays + 1
                if (vm.sportSelected) payload.sportSelected = vm.sportSelected?.name || vm.sportSelected
                // Step 3
                if (vm.objectivesArray.length > 0) payload.objectives = JSON.parse(JSON.stringify(vm.objectivesArray))
                // Step 4
                if (vm.selectedPlace.length > 0) payload.places = JSON.parse(JSON.stringify(vm.selectedPlace))
                // Step 5
                if (vm.equipmentsArray.length > 0) payload.equipments = JSON.parse(JSON.stringify(vm.equipmentsArray))
            }

            await db.collection('users').doc(vm.currentUser.uid).update(payload)
            vm.$emit('finish')
            vm.overlay = false
        },
        goBack() {
            const vm = this
            if (vm.carousel === 0) return vm.$router.push({ name: 'select-profile' })
            return vm.carousel--
        }
    },
}
</script>

<style scoped>

.stepper-wrap {
    position: relative;
    width: 100%;
    max-width: 440px;
}

.container-bottom {
    margin-top: 24px;
}

</style>